import React from "react";
import { FolderIcon } from "@heroicons/react/24/outline";
import { useClickOutside } from "../hooks/useClickOutside";

const FolderSelector = ({
  currentFolder,
  folders,
  onSelect,
  className = "",
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const ref = useClickOutside(() => setIsOpen(false));

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-gray-400 hover:text-white px-3 py-1.5 rounded-lg hover:bg-dark-hover"
      >
        <FolderIcon className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-1 w-48 bg-dark-card rounded-lg shadow-lg border border-gray-800 py-1 z-20">
          {folders.map((folder) => (
            <button
              key={folder}
              onClick={() => {
                onSelect(folder);
                setIsOpen(false);
              }}
              className={`w-full text-left px-4 py-2 text-sm ${
                currentFolder === folder ? "text-blue-500" : "text-gray-400"
              } hover:text-white hover:bg-dark-hover transition-colors`}
            >
              {folder}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FolderSelector;
